"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pagination = void 0;
const typebox_1 = require("@sinclair/typebox");
const page = typebox_1.Type.Number({
    minimum: 1,
    default: 1,
    description: "Page number",
});
const size = typebox_1.Type.Number({
    minimum: 1,
    maximum: 25,
    default: 10,
    description: "Size of the page",
});
const query = typebox_1.Type.Object({
    page: typebox_1.Type.Optional(page),
    size: typebox_1.Type.Optional(size),
});
const response = typebox_1.Type.Object({
    page,
    size,
    total: typebox_1.Type.Number({
        minimum: 0,
        description: "Total number of items matching the query",
    }),
});
exports.pagination = {
    query,
    response,
};
//# sourceMappingURL=pagination.js.map